/**
 * Venn Apps — native cart bridge, fetch observe (early handler may buffer), /cart.js reconcile.
 */
(function () {
  var COOKIE = 'venn_apps_webview';
  /** Staggered reads catch AvisPlus accessory lines that POST after the primary club response. */
  var RECONCILE_DELAYS_MS = [600, 1800, 3500];
  var DEDUP_MS = 400;

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '\\s*=\\s*([^;]*)'));
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  function isWebView() {
    if (typeof document === 'undefined' || !document.documentElement) return false;
    if (document.documentElement.classList.contains('venn-app-webview')) return true;
    return readCookie(COOKIE) === 'true';
  }

  /** Opt-in: ?venn_payload_debug=1 or localStorage.venn_payload_debug=1 (opt out: =0). Venn webview only. */
  function isPayloadDebugEnabled() {
    if (!isWebView()) return false;
    try {
      if (typeof localStorage !== 'undefined' && localStorage.getItem('venn_payload_debug') === '0') {
        return false;
      }
      if (typeof localStorage !== 'undefined' && localStorage.getItem('venn_payload_debug') === '1') {
        return true;
      }
      if (typeof window !== 'undefined' && window.location && window.location.search) {
        var params = new URLSearchParams(window.location.search);
        if (params.get('venn_payload_debug') === '1') return true;
      }
    } catch (e) {}
    return false;
  }

  var recentNotify = Object.create(null);

  function shouldSendDedup(key) {
    var now = Date.now();
    var last = recentNotify[key];
    if (last && now - last < DEDUP_MS) return false;
    recentNotify[key] = now;
    return true;
  }

  function lineDedupKeyFromItem(item) {
    if (item.key) return String(item.key);
    var props = item.properties || {};
    if (Array.isArray(props)) {
      var parts = props
        .map(function (p) {
          return p && p.name !== undefined
            ? String(p.name) + ':' + String(p.value != null ? p.value : '')
            : '';
        })
        .filter(Boolean)
        .sort();
      return String(item.variant_id || '') + ':' + String(item.quantity || 1) + ':' + parts.join('|');
    }
    var keys = Object.keys(props).sort();
    var s = keys
      .map(function (k) {
        return k + ':' + String(props[k]);
      })
      .join('|');
    return String(item.variant_id || '') + ':' + String(item.quantity || 1) + ':' + s;
  }

  var BUNDLE_ATTR = '__venn_bundle_id';
  var BUNDLE_LEAD_ATTR = '__venn_bundle_lead';

  function getLineProperty(props, key) {
    if (!props || key == null) return null;
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        var p = props[i];
        if (p && String(p.name) === String(key)) {
          return p.value != null ? p.value : null;
        }
      }
      return null;
    }
    if (typeof props !== 'object') return null;
    if (!Object.prototype.hasOwnProperty.call(props, key)) return null;
    var v = props[key];
    return v != null ? v : null;
  }

  function normalizeApoOrder(order) {
    if (order == null || order === '') return null;
    var s = String(order);
    var child = s.match(/Added by:\s*(\d+)/);
    if (child) return child[1];
    var parent = s.match(/^(\d{10,})$/);
    return parent ? parent[1] : null;
  }

  function resolveVennBundleId(props) {
    var id = normalizeApoOrder(getLineProperty(props, '_apo_order'));
    if (id) return id;
    var parentKey = getLineProperty(props, '_parentKey');
    if (parentKey != null && parentKey !== '') return String(parentKey);
    var itemKey = getLineProperty(props, '_itemKey');
    if (itemKey != null && itemKey !== '') return String(itemKey);
    return null;
  }

  function isApoChildLine(props) {
    var apoOrder = getLineProperty(props, '_apo_order');
    if (apoOrder != null && /Added by:/i.test(String(apoOrder))) return true;
    if (getLineProperty(props, '_apo_option')) return true;
    var parentKey = getLineProperty(props, '_parentKey');
    return parentKey != null && parentKey !== '';
  }

  function resolveVennBundleLead(props) {
    if (isApoChildLine(props)) return false;
    var hasApo = getLineProperty(props, '_has_apo');
    if (hasApo === 'true' || hasApo === true) return true;
    if (normalizeApoOrder(getLineProperty(props, '_apo_order'))) return true;
    var itemKey = getLineProperty(props, '_itemKey');
    if (itemKey != null && itemKey !== '' && !getLineProperty(props, '_parentKey')) return true;
    return null;
  }

  function collectGroupBundleId(lines) {
    if (!lines || !lines.length) return null;
    for (var i = 0; i < lines.length; i++) {
      var id = resolveVennBundleId(lines[i].properties);
      if (id) return id;
    }
    return null;
  }

  function hasBundleAttribute(attributes) {
    if (!attributes || typeof attributes !== 'object' || Array.isArray(attributes)) {
      return false;
    }
    return Object.prototype.hasOwnProperty.call(attributes, BUNDLE_ATTR);
  }

  function propertiesToAttributes(props) {
    if (!props) return {};
    var out = {};
    if (Array.isArray(props)) {
      props.forEach(function (p) {
        if (!p || p.name === undefined) return;
        if (p.value === null || p.value === undefined) return;
        out[String(p.name)] = String(p.value);
      });
      return out;
    }
    if (typeof props !== 'object') return {};
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (v === null || v === undefined) return;
      out[String(k)] = String(v);
    });
    return out;
  }

  function applyBundleMetadata(attributes, props, groupBundleId) {
    var bundleId = resolveVennBundleId(props);
    if (!bundleId && groupBundleId) bundleId = groupBundleId;
    if (!bundleId) return;
    if (!hasBundleAttribute(attributes)) {
      attributes[BUNDLE_ATTR] = bundleId;
    }
    var lead = resolveVennBundleLead(props);
    if (lead != null) {
      attributes[BUNDLE_LEAD_ATTR] = lead ? 'true' : 'false';
    }
  }

  function lineItemToPayload(line, groupBundleId) {
    var vid = line.variant_id;
    var pid = line.product_id;
    var attributes = propertiesToAttributes(line.properties);
    applyBundleMetadata(attributes, line.properties, groupBundleId);
    var payload = {
      merchandiseId: 'gid://shopify/ProductVariant/' + vid,
      productId: 'gid://shopify/Product/' + pid,
      quantity: Number(line.quantity) || 1,
      attributes: attributes,
    };
    var spa = line.selling_plan_allocation;
    if (spa && spa.selling_plan && spa.selling_plan.id != null) {
      payload.sellingPlanId =
        'gid://shopify/SellingPlan/' + spa.selling_plan.id;
    }
    return payload;
  }

  function logPayloadDebug(line, payload, bridgeResult) {
    if (!isPayloadDebugEnabled()) return;
    var attrs = payload && payload.attributes;
    var props = line && line.properties;
    console.log('[VENN_RAW]', {
      variant_id: line && line.variant_id,
      product_id: line && line.product_id,
      propertiesIsArray: Array.isArray(props),
      properties: props,
      note: 'Shopify /cart/add.js properties — bundle attrs are not stored here',
    });
    console.log('[VENN_PAYLOAD]', {
      merchandiseId: payload && payload.merchandiseId,
      attributesIsArray: Array.isArray(attrs),
      attributesType: attrs == null ? 'null' : typeof attrs,
      attributeKeys: attrs && !Array.isArray(attrs) ? Object.keys(attrs) : [],
      __venn_bundle_id: attrs && attrs[BUNDLE_ATTR] != null ? attrs[BUNDLE_ATTR] : null,
      __venn_bundle_lead: attrs && attrs[BUNDLE_LEAD_ATTR] != null ? attrs[BUNDLE_LEAD_ATTR] : null,
      attributes: attrs,
    });
    console.log('[VENN_BUNDLE]', {
      __venn_bundle_id: attrs && attrs[BUNDLE_ATTR],
      __venn_bundle_lead: attrs && attrs[BUNDLE_LEAD_ATTR],
    });
    console.log('[VENN_BRIDGE]', bridgeResult);
  }

  function postToNative(payload, debugLine) {
    var bridgeResult = { target: 'none', delivered: false };
    try {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.addCartLine &&
        typeof window.webkit.messageHandlers.addCartLine.postMessage === 'function'
      ) {
        window.webkit.messageHandlers.addCartLine.postMessage(payload);
        bridgeResult = { target: 'ios', delivered: true };
        logPayloadDebug(debugLine, payload, bridgeResult);
        return true;
      }
      if (
        window.JavaInterface &&
        typeof window.JavaInterface.addCartLine === 'function'
      ) {
        window.JavaInterface.addCartLine(JSON.stringify(payload));
        bridgeResult = { target: 'android', delivered: true };
        logPayloadDebug(debugLine, payload, bridgeResult);
        return true;
      }
    } catch (e) {}
    logPayloadDebug(debugLine, payload, bridgeResult);
    return false;
  }

  function normalizeAddJsItem(raw) {
    if (!raw) return null;
    var vid =
      raw.variant_id != null
        ? raw.variant_id
        : raw.variantId != null
          ? raw.variantId
          : null;
    var pid =
      raw.product_id != null
        ? raw.product_id
        : raw.productId != null
          ? raw.productId
          : null;
    if (vid == null || pid == null) return null;
    return {
      key: raw.key,
      variant_id: vid,
      product_id: pid,
      quantity: raw.quantity != null ? raw.quantity : 1,
      properties: raw.properties,
      selling_plan_allocation: raw.selling_plan_allocation,
    };
  }

  function notifyRawLineItem(item, groupBundleId) {
    if (!isWebView()) return;
    var normalized = normalizeAddJsItem(item);
    if (!normalized || !normalized.variant_id || !normalized.product_id) return;
    var dk =
      lineDedupKeyFromItem(normalized) + '@' + String(normalized.quantity || 1);
    if (!shouldSendDedup(dk)) return;
    postToNative(lineItemToPayload(normalized, groupBundleId), normalized);
    if (normalized.key) cartLineKeysSeen.add(normalized.key);
  }

  function notifyAddToCart(response) {
    if (!isWebView() || !response) return;
    if (response.status) return;
    var items = response.items;
    if (!items && response.variant_id) items = [response];
    if (!items || !items.length) return;
    var normalized = [];
    for (var i = 0; i < items.length; i++) {
      var n = normalizeAddJsItem(items[i]);
      if (n) normalized.push(n);
    }
    if (!normalized.length) return;
    var groupBundleId = collectGroupBundleId(normalized);
    for (var j = 0; j < normalized.length; j++) {
      notifyRawLineItem(normalized[j], groupBundleId);
    }
  }

  function cartRoot() {
    if (window.MinimogSettings && MinimogSettings.routes && MinimogSettings.routes.root != null)
      return MinimogSettings.routes.root;
    if (window.Shopify && Shopify.routes && Shopify.routes.root != null)
      return Shopify.routes.root;
    return '/';
  }

  /** Shopify cart line keys already mirrored (or present at page load). */
  var cartLineKeysSeen = new Set();
  var reconcileTimers = [];

  function rememberCartLineKeysFromCart(cart) {
    cartLineKeysSeen = new Set();
    (cart.items || []).forEach(function (line) {
      if (line.key) cartLineKeysSeen.add(line.key);
    });
  }

  function processCartForNewLines(cart) {
    var allLines = cart.items || [];
    var newLines = allLines.filter(function (line) {
      return line.key && !cartLineKeysSeen.has(line.key);
    });
    if (!newLines.length) return;
    var groupBundleId = collectGroupBundleId(allLines);
    newLines.forEach(function (line) {
      notifyRawLineItem(line, groupBundleId);
    });
  }

  function syncCartToNative(cb) {
    if (!isWebView()) return;
    fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        processCartForNewLines(cart);
        rememberCartLineKeysFromCart(cart);
        if (typeof cb === 'function') cb(cart);
      })
      .catch(function () {});
  }

  function runCartReconcilePass() {
    fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        processCartForNewLines(cart);
        rememberCartLineKeysFromCart(cart);
      })
      .catch(function () {});
  }

  function scheduleReconcile() {
    if (!isWebView()) return;
    reconcileTimers.forEach(function (id) {
      clearTimeout(id);
    });
    reconcileTimers = [];
    RECONCILE_DELAYS_MS.forEach(function (ms) {
      reconcileTimers.push(
        setTimeout(function () {
          runCartReconcilePass();
        }, ms)
      );
    });
  }

  function patchXHRForCartAdd() {
    try {
      var NativeXHR = window.XMLHttpRequest;
      if (!NativeXHR || NativeXHR.__vennPatched) return;
      var proto = NativeXHR.prototype;
      var origSend = proto.send;
      proto.send = function (body) {
        this.addEventListener(
          'load',
          function handler() {
            this.removeEventListener('load', handler);
            if (!isWebView()) return;
            var u = this.__vennUrl || '';
            if (typeof u !== 'string' || !/(^|\/)cart\/add/.test(u)) return;
            try {
              var text = this.responseText;
              if (!text) return;
              var data = JSON.parse(text);
              if (data && !data.status && window.VennApps && typeof window.VennApps.notifyAddToCart === 'function') {
                window.VennApps.notifyAddToCart(data);
              }
            } catch (errX) {}
          },
          false
        );
        return origSend.apply(this, arguments);
      };
      var origOpen = proto.open;
      proto.open = function () {
        try {
          var urlArg = arguments[1];
          this.__vennUrl = typeof urlArg === 'string' ? urlArg : '';
        } catch (eU) {
          this.__vennUrl = '';
        }
        return origOpen.apply(this, arguments);
      };
      NativeXHR.__vennPatched = true;
    } catch (e2) {}
  }

  function drainBuffer() {
    var buf = window.__vennCartAddBuffer;
    if (!buf || !buf.length) return;
    while (buf.length) notifyAddToCart(buf.shift());
  }

  function applyInternalLinkChannel(e) {
    if (!isWebView()) return;

    var t = e.target && e.target.closest && e.target.closest('a[href]');
    if (!t || t.getAttribute('data-venn-skip-link') != null) return;
    var href = t.getAttribute('href');
    if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0)
      return;
    if (href.indexOf('/checkout') !== -1) return;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return;
      if (u.searchParams.get('sales_channel') === 'venn_apps') return;
      u.searchParams.set('sales_channel', 'venn_apps');
      t.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (err2) {}
  }

  /** Seed known cart line keys so we do not replay on startup */
  function initCartBaseline() {
    if (!isWebView()) return;
    fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        rememberCartLineKeysFromCart(cart);
      })
      .catch(function () {});
  }

  window.VennApps = {
    isWebView: isWebView,
    isPayloadDebugEnabled: isPayloadDebugEnabled,
    notifyAddToCart: notifyAddToCart,
    syncCartToNative: syncCartToNative,
    scheduleCartReconcile: scheduleReconcile,
    normalizeApoOrder: normalizeApoOrder,
    resolveVennBundleId: resolveVennBundleId,
    resolveVennBundleLead: resolveVennBundleLead,
    lineItemToPayload: lineItemToPayload,
  };

  if (!isWebView()) return;

  patchXHRForCartAdd();

  function suppressOpusCartDrawerChrome() {
    try {
      if (typeof window.opusOpen === 'function') {
        window.opusOpen = function () {};
      }
    } catch (e) {}
  }

  initCartBaseline();
  drainBuffer();
  suppressOpusCartDrawerChrome();

  if (isPayloadDebugEnabled()) {
    console.log('[VENN_DEBUG]', {
      enabled: true,
      bundleAttr: BUNDLE_ATTR,
      bundleLeadAttr: BUNDLE_LEAD_ATTR,
      note:
        'Bundle metadata is on native bridge payload.attributes only — not Shopify cart properties. Attribute names use two leading underscores.',
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drainBuffer();
    suppressOpusCartDrawerChrome();
    document.addEventListener('product-ajax:added', scheduleReconcile);
    document.addEventListener('click', applyInternalLinkChannel, true);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    document.addEventListener('product-ajax:added', scheduleReconcile);
    document.addEventListener('click', applyInternalLinkChannel, true);
    suppressOpusCartDrawerChrome();
  }

  window.addEventListener('load', suppressOpusCartDrawerChrome);
})();
